import { createBrowserHistory } from 'history'

const history = createBrowserHistory()
// const history = useHistory()
export default history
